var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 9.66667V11M4.66602 6.68587C4.9803 6.66667 5.36774 6.66667 5.86602 6.66667H10.1327C10.6309 6.66667 11.0184 6.66667 11.3327 6.68587M4.66602 6.68587C4.2738 6.7098 3.99554 6.76367 3.75804 6.88467C3.38171 7.0764 3.07575 7.38233 2.884 7.75867C2.66602 8.18653 2.66602 8.74653 2.66602 9.86667V10.8C2.66602 11.9201 2.66602 12.4801 2.884 12.908C3.07575 13.2843 3.38171 13.5903 3.75804 13.782C4.18586 14 4.74591 14 5.86602 14H10.1327C11.2528 14 11.8128 14 12.2407 13.782C12.617 13.5903 12.9229 13.2843 13.1147 12.908C13.3327 12.4801 13.3327 11.9201 13.3327 10.8V9.86667C13.3327 8.74653 13.3327 8.18653 13.1147 7.75867C12.9229 7.38233 12.617 7.0764 12.2407 6.88467C12.0031 6.76367 11.7249 6.7098 11.3327 6.68587M4.66602 6.68587V5.33333C4.66602 3.49239 6.1584 2 7.99935 2C9.84028 2 11.3327 3.49239 11.3327 5.33333V6.68587",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsLock);
export default __webpack_public_path__ + "static/media/isLock.0ac2481abc058589d5cde827f8d7b147.svg";
export { ForwardRef as ReactComponent };